import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import Player from '@vimeo/player';
import { initializeDropdowns, toggleAriaExpanded } from './utils';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


// Register GSAP plugins

gsap.registerPlugin(ScrollTrigger);


// Dropdowns

initializeDropdowns();


// Header scroll adjustment

function handleScroll() {
    document.body.classList.toggle('user-has-scrolled', window.scrollY > 0);
}

window.addEventListener('scroll', handleScroll);
handleScroll();


// Header flyout

const headerFlyoutToggle = document.querySelector('.header-flyout-toggle');
const headerFlyoutAnimation = gsap.timeline({ paused: true, defaults: { duration: 0.4, ease: 'power3.inOut' } });

headerFlyoutAnimation
    .set('.burger', { transformOrigin: '50% 50%' })
    .to(headerFlyoutToggle, { rotate: 90 }, 0)
    .to('.burger-1, .burger-4', { scaleX: 0, opacity: 0 }, 0)
    .to('.burger-2', { rotate: 45 }, 0)
    .to('.burger-3', { rotate: -45 }, 0);

headerFlyoutToggle?.addEventListener('dropdown:before-open', event => {
    if (event.detail.isExpanded) {
        headerFlyoutAnimation.reverse();
    } else {
        headerFlyoutAnimation.play();
    }
});


// Hero scroll button

const heroScrollButton = document.querySelector('.hero-scroll');

heroScrollButton?.addEventListener('click', () => {
    const nextSection = heroScrollButton.closest('section').nextElementSibling;

    if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
    }
});


// Sliders

const sliderBlocks = document.querySelectorAll('[data-slider]');

sliderBlocks.forEach(block => {
    const container = block.querySelector('[data-slider-container]');
    const autoscroll = container?.dataset.autoscroll === 'true';
    const prevButton = block.querySelector('[data-slider-prev]');
    const nextButton = block.querySelector('[data-slider-next]');
    const navContainer = prevButton?.parentElement;

    if (!container) return;

    const plugins = [];
    const options = {
        align: 'start',
    };

    if (autoscroll) {
        plugins.push(AutoScroll({
            stopOnInteraction: false,
            stopOnMouseEnter: true,
            speed: 1,
        }));
        options.loop = true;
    }

    const embla = EmblaCarousel(container, options, plugins);

    if (prevButton && nextButton) {
        function updateSlider() {
            prevButton.disabled = !embla.canScrollPrev();
            nextButton.disabled = !embla.canScrollNext();
            navContainer?.classList.toggle('visible', embla.canScrollPrev() || embla.canScrollNext());
        }

        window.addEventListener('resize', () => updateSlider());
        embla.on('select', updateSlider);
        updateSlider();

        prevButton.addEventListener('click', () => embla.scrollPrev());
        nextButton.addEventListener('click', () => embla.scrollNext());
    }
});


// Accordion blocks

const accordionBlocks = document.querySelectorAll('.accordion');

accordionBlocks.forEach(block => {
    const items = block.querySelectorAll('.accordion-item');

    let currentItem;

    items.forEach(item => {
        const toggle = item.querySelector('.accordion-item-toggle');
        const indicator = item.querySelector('.accordion-item-indicator');
        const collapse = item.querySelector('.accordion-item-collapse');

        const animation = gsap.timeline({ paused: true, defaults: { duration: 0.3, ease: 'power3.inOut' } });
        animation.set(collapse, { height: 0, opacity: 0, overflow: 'hidden', display: 'block' });
        animation.to(indicator, { rotate: 180 }, 0);
        animation.to(collapse, { height: 'auto', opacity: 1 }, 0);

        toggle.addEventListener('click', () => {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';

            if (currentItem) {
                toggleAriaExpanded(currentItem.toggle, false);
                currentItem.animation.reverse();
                currentItem = null;
            }

            if (!isOpen) {
                toggleAriaExpanded(toggle, true);
                animation.play();
                currentItem = { toggle, animation };
            }
        });
    });
});


// Vimeo background videos

const videoElements = document.querySelectorAll('[data-video-url]');

videoElements.forEach(videoElement => {
    const toggleButton = videoElement.querySelector('[data-video-toggle]');

    const player = new Player(videoElement, {
        url: videoElement.dataset.videoUrl,
        background: true,
    });

    videoElement.classList.add('playing');

    toggleButton?.addEventListener('click', () => {
        player.getPaused().then(paused => {
            videoElement.classList.toggle('playing', paused);
            paused ? player.play() : player.pause();
        });
    });
});


// Numbers blocks

const numberBlocks = document.querySelectorAll('.numbers');

numberBlocks.forEach(block => {
    const numbers = block.querySelectorAll('.numbers-item-number');

    numbers.forEach(number => {
        const targetValue = parseFloat(number.dataset.targetValue) || 0;

        gsap.to(number, {
            innerText: targetValue,
            duration: 2,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: block,
                start: 'top 80%',
            },
            snap: { innerText: 1 },
            onUpdate: () => {
                number.innerText = Math.floor(number.innerText).toLocaleString();
            },
        });
    });
});


// Search category selection

const categorySelectors = document.querySelectorAll('.search-form-category');

categorySelectors.forEach(selector => {
    const hiddenInput = selector.querySelector('input[type="hidden"]');
    const buttons = selector.querySelectorAll('.search-form-category-item');
    const toggle = selector.querySelector('.search-form-category-toggle');
    
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const icon = toggle.querySelector('.search-form-category-icon');

            hiddenInput.value = button.dataset.value || '';
            icon.outerHTML = button.querySelector('svg').outerHTML;

            toggle.click();
        });
    });
});


// Cache-proofing dynamic weather

const dynamicWeatherContainers = document.querySelectorAll('.weather-dynamic');

dynamicWeatherContainers.forEach(container => {
    const city = container.dataset.city;

    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'action=get_weather&city=' + encodeURIComponent(city),
    }).then(response => response.text()).then(html => {
        dynamicWeatherContainers.forEach(container => {
            container.innerHTML = html;
        });
    });

});